import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from '../../utils';

export const fetch = async (query: { ProductId: number; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { ProductId, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchGet(
    `/InventoryEnquiry/Product/${ProductId}/Pricing/Prices`,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        InventoryPricess: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.InventoryPricess) {

            return {
              records: result.InventoryPricess.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};

export const fetchSummary = (query) => {
  const { ProductId, Warehouse } = query;

  return fetchGet(`InventoryEnquiry/PriceDetailsSummary/Product/${ProductId}`, { Warehouse }, 'Inline')
    .then((result) => result ? objectify(result.PriceSummary, null, 'Inline') : null);
};
